
<div class="sunset-container">
    <div style=" position: absolute; z-index: 999999; left: 0px; right: 0px; top: 0px; bottom: 0px; backdrop-filter: grayscale(1); pointer-events: none;"></div>
    <h2 style="margin: 4rem 0 0 0 ">🥀 Rest in peace 🥀</h2>
    <span>The Audience Anarchy script editor</span>
    <img style="height: 25vh" src="/img/scripteditor.png" alt="">
    <span style="opacity: 0.75;">November 17, 2023 - June 1, 2026</span>
    <span style="font-size: 0.75em; opacity: 0.75;">
        Thanks to everyone who submitted scripts and allowed Audience Anarchy to become what it is today.<br>
        This wouldn't have been possible without you.
    </span>

    <mat-icon class="bounce" style="position: absolute; bottom: 2rem; left: 50%; transform: translateX(-50%);">arrow_downward</mat-icon>
    
</div>

<div style="max-width: 1200px; margin: 0 auto;">
    <h2>What happened?</h2>
    <p>We are no longer accepting submissions for Audience Anarchy scripts. This decision allows Jar to focus on working on upcoming games.</p> 
    <h2>What happens to existing scripts?</h2>
    <p>Existing scripts will continue to work as intended. They will not be removed or deleted.</p>
    <h2>Can I still play Audience Anarchy?</h2>
    <p>Yes! The game is still available to play. The only thing that has changed is that no new scripts will be added, but all existing scripts will continue to work as intended. You can still access them from the Scripts page.</p>
    <h2>Why are the scripts no longer being accepted?</h2>
    <p>Maintenance of the script roster has become difficult to sustain. By focusing on new projects, we can ensure a better experience for everyone involved.</p>
    
    <h1 style="margin-top: 5rem; font-size: 2vw;">Thank you to all authors who have made Audience Anarchy possible!</h1>
    <div style="margin: 0 auto; max-width: 1200px;">
        <div style="display: flex; gap: 0.25rem; flex-wrap: wrap;">
            @for (author of authors; track author.name) {
                <mat-chip>
                    @if (author.avatar) {
                        <img (error)="author.avatar = undefined" matChipAvatar [src]="getAvatar(author.avatar)" />
                    } @else {
                        <mat-icon matChipAvatar>account_circle</mat-icon>
                    }
                    {{author.name}}
                </mat-chip>
            }
        </div>
    </div>
</div>
